import React from "react";
import { Row, Table } from "react-bootstrap";
import {useSelector } from "react-redux";
import { Frequencies, FrequencyValues,BotTypeName } from "../../../Const";
import LeftRightForm from "../new-bot/modules/LeftRightForm";
import { useTranslation } from "react-i18next";

const RentBotSetting = (props) => {
  const { bot } = props;
  const {t} = useTranslation()
  const exchangePair = bot.exchange_pair || {};
  const exchange = exchangePair.exchange || {};
  const pair = exchangePair.pair || {};
  const indicators = bot.bot_indicators || [];
  const stoploss = bot.stop_loss || 0;
  const theme = useSelector((state) => state.settings.selected_theme);
  const entryIndicators =
    indicators &&
    indicators
      .filter((item) => item.type == "entry")
      .map((item) => item.name)
      .join(", ");
  const exitIndicators =
    indicators &&
    indicators
      .filter((item) => item.type == "exit")
      .map((item) => item.name)
      .join(", ");

  return (
    <div className="col-lg-6 col-md-6">
    <div className="bot-detail-left">
      <div className="bot-detail-left-header">
        <label>
          <img src="/images/overview-icon.svg" alt=""/>
          Overview
        </label>
        <label>
          <img src={exchange.image} alt=""/>
          {exchange.name}
        </label>
      </div>
      <div className="bot-detail-left-body">
        <div className="row">
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("pair")}</span>
              <h6>{pair && `${pair.from}/${pair.to}`}</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("bot-type")}</span>
              <h6>{bot && BotTypeName[bot.type]}</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("strategy")}</span>
              <h6 >{bot && bot.strategy}</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("Extended Trading Hour")}</span>
              <h6>{bot && parseInt(bot.extended_trading_hour)?"Yes":"No"}</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("Enable 24 Hour")}</span>
              <h6>{((bot && parseInt(bot.trading_hour_247)) || exchange && exchange.id===6 )?"Yes":"No"}</h6>
            </div>
          </div>
          <div className="col-6">
            <div className="bdol-item">
              <span>{t("auto-close-trading")}</span>
              <h6>{bot && parseInt(bot.end_day_auto_close)?"Yes":"No"}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default RentBotSetting;
